"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtraGas = exports.GAS_MULTIPLUER = void 0;
const bignumber_js_1 = require("bignumber.js");
exports.GAS_MULTIPLUER = 1.2;
const getExtraGas = (estimatedGas) => +new bignumber_js_1.BigNumber((estimatedGas === null || estimatedGas === void 0 ? void 0 : estimatedGas.toString()) || 0).times(exports.GAS_MULTIPLUER).toFixed(0);
exports.getExtraGas = getExtraGas;
